import { useParams, Link, Navigate } from 'react-router-dom'
import SEO from '../components/SEO'
import blogPosts from '../data/blogPosts'

function formatDate(dateStr) {
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

function renderMarkdown(md) {
  const lines = md.split('\n')
  const elements = []
  let i = 0

  while (i < lines.length) {
    const line = lines[i]

    if (line.startsWith('## ')) {
      elements.push(
        <h2 key={i} className="text-2xl font-bold text-black mt-10 mb-4">
          {line.slice(3)}
        </h2>
      )
    } else if (line.startsWith('### ')) {
      elements.push(
        <h3 key={i} className="text-lg font-semibold text-black mt-6 mb-2">
          {line.slice(4)}
        </h3>
      )
    } else if (/^\d+\.\s/.test(line)) {
      const listItems = []
      while (i < lines.length && /^\d+\.\s/.test(lines[i])) {
        listItems.push(
          <li key={i} className="ml-1">
            <span
              dangerouslySetInnerHTML={{
                __html: formatInline(lines[i].replace(/^\d+\.\s/, '')),
              }}
            />
          </li>
        )
        i++
      }
      elements.push(
        <ol key={`ol-${i}`} className="list-decimal pl-6 space-y-2 text-neutral-700">
          {listItems}
        </ol>
      )
      continue
    } else if (line.startsWith('- ')) {
      const listItems = []
      while (i < lines.length && lines[i].startsWith('- ')) {
        listItems.push(
          <li key={i}>
            <span
              dangerouslySetInnerHTML={{
                __html: formatInline(lines[i].slice(2)),
              }}
            />
          </li>
        )
        i++
      }
      elements.push(
        <ul key={`ul-${i}`} className="list-disc pl-6 space-y-2 text-neutral-700">
          {listItems}
        </ul>
      )
      continue
    } else if (line.trim() === '') {
      // skip blank lines
    } else {
      elements.push(
        <p
          key={i}
          className="text-neutral-700 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: formatInline(line) }}
        />
      )
    }
    i++
  }

  return elements
}

function formatInline(text) {
  return text
    .replace(/\*\*(.+?)\*\*/g, '<strong class="text-black font-semibold">$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
}

export default function BlogPost() {
  const { slug } = useParams()
  const post = blogPosts.find((p) => p.slug === slug)

  if (!post) return <Navigate to="/blog" replace />

  const currentIndex = blogPosts.indexOf(post)
  const prevPost = blogPosts[currentIndex - 1]
  const nextPost = blogPosts[currentIndex + 1]

  return (
    <div className="min-h-screen bg-white text-black">
      <SEO
        title={post.title}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        type="article"
      />
      <nav className="sticky top-0 z-50 bg-white/97 backdrop-blur-md border-b border-neutral-200">
        <div className="flex items-center justify-between px-5 py-4 md:px-10 lg:px-16">
          <Link to="/" className="no-underline">
            <img src="/waitherelogo.png" alt="Waithere" className="h-7 w-auto" />
          </Link>
          <Link
            to="/blog"
            className="text-sm text-neutral-500 no-underline hover:text-black transition-colors"
          >
            ← Todos os artigos
          </Link>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-5 py-16 sm:px-8 lg:px-0">
        <article>
          <header className="mb-10">
            <p className="text-sm text-neutral-400 mb-3">
              {formatDate(post.date)} · {post.readTime} de leitura · {post.category}
            </p>
            <h1 className="text-3xl sm:text-4xl font-bold leading-tight">{post.title}</h1>
          </header>

          <div className="space-y-4 text-[15px] leading-relaxed">
            {renderMarkdown(post.content)}
          </div>
        </article>

        <hr className="my-12 border-neutral-200" />

        <div className="flex flex-col sm:flex-row justify-between gap-4">
          {prevPost ? (
            <Link
              to={`/blog/${prevPost.slug}`}
              className="text-sm text-neutral-500 no-underline hover:text-black transition-colors"
            >
              ← {prevPost.title}
            </Link>
          ) : (
            <span />
          )}
          {nextPost ? (
            <Link
              to={`/blog/${nextPost.slug}`}
              className="text-sm text-neutral-500 no-underline hover:text-black transition-colors text-right"
            >
              {nextPost.title} →
            </Link>
          ) : (
            <span />
          )}
        </div>

        <div className="mt-12 bg-neutral-50 rounded-2xl p-8 text-center">
          <h3 className="text-lg font-semibold mb-2">Pronto para digitalizar seu restaurante?</h3>
          <p className="text-neutral-500 text-sm mb-5">
            Crie sua conta gratuita e comece a usar a WaitHere hoje mesmo.
          </p>
          <a
            href="https://dash.waithere.com.br"
            className="inline-block bg-black text-white font-bold no-underline py-3 px-8 rounded-full text-sm hover:opacity-80 transition-opacity"
          >
            Começar grátis →
          </a>
        </div>
      </main>
    </div>
  )
}
